import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatTable } from '@angular/material/table';
import {
  PamlabApiServiceService,
  DataService,
  SnackbarService,
  ScreenSizeService,
  RouteService,
} from '@/shared/services';
import { CourseGradeEstimationResponse } from '../../../../../server/schemas';

export interface Row {
  method: string;
  target_course: string;
  taken_courses: string;
  prediction: string;
  lower_range: string;
  upper_range: string;
  prob_pass: number;
}

@Component({
  selector: 'course-grade-estimation-content',
  templateUrl: './course-grade-estimation-content.component.html',
  styleUrls: ['./course-grade-estimation-content.component.css'],
  standalone: false,
})
export class CourseGradeEstimationContentComponent
  implements OnInit, OnDestroy
{
  public dataPending!: boolean;
  public displayedColumns: string[] = [
    'method',
    'target_course',
    'taken_courses',
    'lower_range',
    'upper_range',
    'prob_pass',
    'action',
  ];
  public dataSource: Row[] = [];
  public spinnerOn: boolean = false;
  private subscription: Subscription = new Subscription();
  public courseGradeEstimationData!: CourseGradeEstimationResponse;
  public targetCourse = '';
  public mobileView: boolean = false;
  @ViewChild(MatTable) table!: MatTable<Row>;

  constructor(
    private dataService: DataService,
    private snackbarService: SnackbarService,
    private apiService: PamlabApiServiceService,
    private screenSizeService: ScreenSizeService,
    private routeService: RouteService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.dataService.getData().subscribe({
        next: (dataStream) => {
          if (dataStream.data) {
            this.courseGradeEstimationData =
              dataStream.data as CourseGradeEstimationResponse;
            this.populateRow(this.courseGradeEstimationData);
          }

          dataStream.error &&
            this.snackbarService.open(dataStream.error.message, 'error');
        },
      }),
    );

    this.subscription.add(
      this.dataService.getPendingData().subscribe((pending) => {
        this.dataPending = pending;
      }),
    );

    this.subscription.add(
      this.screenSizeService.screenView$.subscribe((view) => {
        this.mobileView = view === 'mobile';
      }),
    );
  }

  populateRow(data: any) {
    if (!data.taken_courses) {
    } else {
      this.dataSource.unshift({
        method: data.method,
        lower_range: data.lower_range,
        prediction: data.prediction,
        prob_pass: Math.round(data.prob_pass * 100) / 100,
        taken_courses: data.taken_courses.join(', '),
        target_course: data.target_course,
        upper_range: data.upper_range,
      });
    }

    this.table && this.table.renderRows();
  }

  deleteRow(event: Event, row: Row) {
    event.stopPropagation();
    this.dataSource = this.dataSource.filter(
      (dataRow) => !this.isSameRow(dataRow, row),
    );
  }

  isSameRow(x: Row, y: Row): boolean {
    return (
      x.method === y.method &&
      x.target_course === y.target_course &&
      x.taken_courses === y.taken_courses
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  // set local var to true after submit form button is clicked
  leftSideComponentFunction(spinner: boolean) {
    this.spinnerOn = spinner;
  }

  navigateToGlossaryOfTerms(termValue: string) {
    this.routeService.navigateNewTab('/glossary-of-terms', {
      term_value: termValue,
    });
  }
}
